import React, { useEffect, useState } from 'react'
import Popup from '../Popup/BasePopup'
import Button from '../CommonFields/Button'
import { toastError, toastSuccess } from '../../Utilities/toast'
import { getAllLanaguageList, getFavLanguage, updateFavLanguage } from '../../api/public.api'
import i18next, { t } from 'i18next'
import Cookies from "js-cookie";
import ListLoader from '../Common/ListLoader';
const LaguegueSelection = ({ isOpen, title, onClose }) => {
    const [isLoading, setLoading] = useState(false);
    const [languageList, setLanguageList] = useState([]);
    const [selectedLanguage, setSelectedLanguage] = useState('en')
    const codes = ['E', 'अ', 'ض']

    useEffect(() => {
        fetchLanguages();
    }, [])

    const fetchLanguages = async () => {
        try {
            setLoading(true)
            const response = await getAllLanaguageList();
            setLoading(false)
            if (response?.success && response?.data) {
                setLanguageList(response?.data);
            }
        } catch (error) { setLoading(false) }
    }

    useEffect(() => {
        console.log(languageList)
        if (languageList?.length > 0) {
            fetchFavLanguage();
        }
    }, [languageList])

    const fetchFavLanguage = async () => {
        try {
            const response = await getFavLanguage();
            if (response?.success) {
                var data = languageList.find(element => element.code === response?.language);
                setSelectedLanguage(data);
            }
        } catch (error) { }
    }

    const handlerSubmit = async () => {
        if (!selectedLanguage) {
            toastError('Select atleast one language')
        }
        updateLanguage(selectedLanguage);
        localStorage.setItem("languageData", JSON.stringify(selectedLanguage));
        try {
            var response = await updateFavLanguage({language :selectedLanguage?.code})
            onClose(true);
        } catch (error) { }
    };

    const updateLanguage = (selectedLanguage) => {
        const lang_code = selectedLanguage?.code?.toLowerCase();
        i18next.changeLanguage(lang_code);
        localStorage.setItem("langName", lang_code);
        localStorage.setItem("i18nextLng", lang_code);
        Cookies.set("i18nextLng", lang_code);
        const linkTag = document.getElementById('bootstrap_css');
        document.documentElement.dir =
            lang_code === "ar" ? "rtl" : "ltr";

        if (lang_code === "id") {
            document.documentElement.setAttribute('lang', 'id');
        }
        if (lang_code === "ar") {
            document.documentElement.setAttribute('lang', 'ar');
            linkTag?.setAttribute(
                'href',
                `${process.env.REACT_APP_CLIENT_BASE_URL}asserts/css/bootstrap.rtl.min.css`
            );
        }
        document.title = t('title')
        document.documentElement.setAttribute('lang', lang_code);
        // window.location.href = "/more";
    };

    return (
        <Popup isOpen={isOpen} title={title} onClose={onClose}>
            <div className='language scroll-none'>
                {!isLoading ?
                    languageList?.length > 0 ? languageList?.map((language, ind) => {
                        return (
                            <div className='d-flex' onClick={() => setSelectedLanguage(language)}>
                                <div className={`lang-box me-3 ${selectedLanguage?.code === language?.code ? "border-active" : ""}`} > {language?.code} </div>
                                <span>{language?.name}</span>
                            </div>
                        )
                    }) : <>
                    <div className='w-100'>
                    <div className="text-center w-100" >{t("common.no_data_found")}</div>
                    </div>
                    </>
                    : <>{isLoading && <div className='w-100 d-flex align-content-center'> <ListLoader/></div>}</>
                }
            </div>
            <div className='mt-4'>
                <Button text={t("common.submit")} onClick={handlerSubmit} data-lang={selectedLanguage} />
            </div>
        </Popup>
    )
}

export default LaguegueSelection